module.exports = __webpack_public_path__ + "static/media/Rueda-Herramienta-Inferior.46e571a6.jpg";